import { Suspense, lazy, useContext } from 'react';
import { FilterContext } from '~js/React/filterTools';
import { EstateType } from '~js/React/Enums';
const ExtraCriterias = lazy(() => import('./ExtraCriterias'));
const CommercialCriterias = lazy(
  () => import('../CommercialCriteriasComponent')
);
const FarmCriterias = lazy(() => import('../FarmCriteriasComponent'));
import RangeSliders from '../RangeSliderComponents/RangeSlidersComponent';
import useMediaQuery from '../../CustomHooks/useMediaQuery';
const RangeSlidersExtraCriteria = lazy(
  () => import('../RangeSliderComponents/RangeSlidersExtraCriteria')
);
const ExtraCriteriasFilter = ({
  tabIndex,
  showExtraCriterias,
}: {
  tabIndex?: number;
  showExtraCriterias: boolean;
}): JSX.Element => {
  const filterContext = useContext(FilterContext);
  const isBigDesktop = useMediaQuery('(min-width: 91rem)');

  return (
    <div
      id="extra-criterias"
      className="md:grid lg:grid-cols-1 md:grid-cols-2 mb-3 duration-200 transition-all overflow-hidden"
    >
      {filterContext.tags.some(
        (t) =>
          t.type === 'estateType' &&
          (t.estateType === EstateType.Agriculture ||
            t.estateType === EstateType.Commercial)
      ) &&
        showExtraCriterias && (
          <div className="px-3 md:px-0 divide-y bg-grey10 rounded-md mt-2">
            {filterContext.tags.some(
              (t) =>
                t.type === 'estateType' &&
                t.estateType === EstateType.Agriculture
            ) && (
              <Suspense>
                <FarmCriterias tabIndex={tabIndex} />
              </Suspense>
            )}
            {filterContext.tags.some(
              (t) =>
                t.type === 'estateType' &&
                t.estateType === EstateType.Commercial
            ) && (
              <Suspense>
                <CommercialCriterias tabIndex={tabIndex} />
              </Suspense>
            )}
          </div>
        )}
      <RangeSliders tabIndex={tabIndex} />
      {(showExtraCriterias || isBigDesktop) && (
        <Suspense>
          <RangeSlidersExtraCriteria tabIndex={tabIndex} />
        </Suspense>
      )}

      {showExtraCriterias && (
        <Suspense>
          <ExtraCriterias />
        </Suspense>
      )}
    </div>
  );
};
export default ExtraCriteriasFilter;
